<section class="tw-bg-white font-noto tw-pl-4 tw-my-2">
  <div class="tw-text-600 tw-mb-2 tw-font-semibold tw-p-3" i18n="@@caseStudies">
    Case studies
  </div>
  <div class="tw-overflow-x-scroll tw-whitespace-nowrap tw-space-x-2">
    @for (testimonial of testimonialCaseStudies; track testimonial; let i = $index) {
      <a class="tw-inline-block tw-pb-2">
        <div class="card tw-bg-green-100 tw-rounded-lg tw-p-4 tw-w-52 tw-flex tw-flex-col tw-justify-between" [ngClass]="getCardBgClass(i)" (click)="redirectToCaseStudiesInfo(i)">
          <img class="tw-object-cover tw-rounded-md tw-mb-4 tw-w-[108px]" src="https://cdn.cureskin.com/app/img/testimonials/case-studies/{{testimonial['imageName']}}-t.png" />
          <div class="tw-flex tw-justify-between tw-items-center tw-pb-[2.5]">
            <p class="tw-text-200 tw-text-black tw-w-auto tw-whitespace-normal tw-break-words">
              {{testimonial['name']}}
            </p>
          </div>
          <div class="tw-text-500 tw-text-black tw-font-semibold tw-mb-1" i18n="@@treatedFor">
          Treated for:
        </div>
          <div class="tw-text-500 tw-text-black tw-font-semibold tw-mb-1">
            {{testimonial['concern']}}
          </div>
          <div class="tw-flex tw-mt-2">
            <div
              class='tw-h-8 tw-w-fit tw-px-2 tw-font-body tw-font-bold tw-text-200 tw-text-white tw-flex tw-items-center tw-gap-1 tw-rounded-3 tw-bg-teal-600'
              >
              <span i18n="@@readMore">Read More</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="16" width="16"><path fill="#fff" d="m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z"/></svg>
            </div>
          </div>
        </div>
      </a>
    }
  </div>
</section>
